import { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Logo from '/assets/logo/logo_white.svg';

export const ErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error) {
      Sentry.captureException(error, {
        tags: { type: 'react_render_error' },
      });
    }
  }, [error]);

  return (
    <Box
      sx={{
        backgroundColor: 'primary.main',
        color: 'white',
        width: '100dvw',
        height: '100dvh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 5,
      }}
    >
      <Box sx={{ position: 'fixed', top: '10px', left: '10px' }}>
        <img src={Logo} width="80%" />
      </Box>
      <Typography variant="h3" sx={{ color: 'white' }}>
        網路系統異常，請重新整理網頁再試。
      </Typography>
    </Box>
  );
};
